import { Box } from "@mui/material";
import PrimaryButton from "../PrimaryButton";
import QuantityNumbers from "../QuantityNumbers";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { userRoleAtom } from "../../../atom/atoms";
import { useAtom } from "jotai";

// const ContainerWithStyles = styled("div")`
//   background-color: ${(props) => props.theme.palette.planInfo.background};
//   display: flex;
//   flex-direction: row;
//   border-radius: 13.75rem;
//   width: ${(props) => (props.theme.breakpoints.up("md") ? `21rem` : `17rem`)};
//   height: ${(props) =>
//     props.theme.breakpoints.up("lg") ? `3.5625rem` : `2.5rem`};
//   align-items: center;
//   padding: 1.25rem;
//   justify-content: space-between;
//   flex-shrink: 0;
// `;

const StyledBox = styled(Box)`
  background-color: ${(props) => props.theme.palette.planInfo.background};
  display: flex;
  align-items: center;
  flex-direction: row;
  border-radius: 13.75rem;
  max-height: ${(props) =>
    props.theme.breakpoints.up("lg") ? `3.5625rem` : `2.5rem`};
  padding: 1.25rem;
`;

const PlanProductInfo = (props) => {
  const navigate = useNavigate();
  const [userRole] = useAtom(userRoleAtom);
  const hasUserRole = userRole === "user";
  return (
    <StyledBox>
      <QuantityNumbers
        current={props.current}
        max={props.max}
        quantityFrom={props?.quantityFrom}
        quantityTo={props?.quantityTo}
      />
      {/*TODO: This button need to navigate to Upgrade plan page*/}
      {props.upgradePlan && !hasUserRole && (
        <PrimaryButton
          onClick={() => navigate("/upgradePlan")}
          sx={{
            fontSize: [7, 9],
            marginLeft: [5, 10],
            display: "flex",
            flexDirection: "row",
            whiteSpace: "nowrap",
            minWidth: "max-content",
            width: "100%",
          }}
        >
          Upgrade your plan
        </PrimaryButton>
      )}
    </StyledBox>
  );
};

export default PlanProductInfo;
